import { Tag } from "antd";
import { useEffect } from "react";
import { useCallback, useState } from "react";
const remarksBill = require("../assests/icons/d_bill.png");
const remarksBusiness = require("../assests/icons/d_business.png");
const remarksEntertainment = require("../assests/icons/d_entertainment.png");
const remarksfood = require("../assests/icons/d_food.png");
const remarksHelth = require("../assests/icons/d_health.png");
const remarksOthers = require("../assests/icons/d_others.png");
const remarksShopping = require("../assests/icons/d_shopping.png");
const remarksTravel = require("../assests/icons/d_travel.png");
const remarksInvestment = require("../assests/icons/d_investment.png");
const remarksBillSelected = require("../assests/icons/g_bill.png");
const remarksBusinessSelected = require("../assests/icons/g_business.png");
const remarksEntertainmentSelected = require("../assests/icons/g_entertainment.png");
const remarksfoodSelected = require("../assests/icons/g_food.png");
const remarksHelthSelected = require("../assests/icons/g_health.png");
const remarksOthersSelected = require("../assests/icons/g_others.png");
const remarksShoppingSelected = require("../assests/icons/g_shopping.png");
const remarksTravelSelected = require("../assests/icons/g_travel.png");
const remarksInvestmentSelected = require("../assests/icons/g_investment.png");

const defaultRemarksList = [
  {
    icon: remarksfood,
    iconSelected: remarksfoodSelected,
    label: "Food and Drinks",
    iconStyle: { width: 25, height: 30 },
    value: "FOOD",
    active: false,
  },
  {
    icon: remarksEntertainment,
    iconSelected: remarksEntertainmentSelected,
    label: "Entertainment",
    iconStyle: { width: 30, height: 30 },
    value: "ENTERTAINMENT",
    active: false,
  },
  {
    icon: remarksBill,
    iconSelected: remarksBillSelected,
    label: "Utility Bills",
    iconStyle: { width: 22, height: 30 },
    value: "BILLS",
    active: false,
  },
  {
    icon: remarksTravel,
    iconSelected: remarksTravelSelected,
    label: "Travel",
    iconStyle: { width: 30, height: 30 },
    value: "TRAVEL",
    active: false,
  },
  {
    icon: remarksHelth,
    iconSelected: remarksHelthSelected,
    label: "Health",
    iconStyle: { width: 28, height: 26 },
    value: "HEALTH",
    active: false,
  },
  {
    icon: remarksInvestment,
    iconSelected: remarksInvestmentSelected,
    label: "Investment",
    iconStyle: { width: 28, height: 30 },
    value: "INVESTMENT",
    active: false,
  },
  {
    icon: remarksShopping,
    iconSelected: remarksShoppingSelected,
    label: "Shopping",
    iconStyle: { width: 28, height: 30 },
    value: "SHOPPING",
    active: false,
  },
  {
    icon: remarksBusiness,
    iconSelected: remarksBusinessSelected,
    label: "Business",
    iconStyle: { width: 35, height: 30 },
    value: "BUSINESS",
    active: false,
  },
  {
    icon: remarksOthers,
    iconSelected: remarksOthersSelected,
    label: "Others",
    iconStyle: { width: 30, height: 30 },
    value: "OTHERS",
    active: false,
  },
];

export default function RemarkTags({
  setSelected,
  setRemarksTagList,
  remarksTagList = [],
}) {
  const [remarksList, setRemarksList] = useState([]);

  useEffect(() => {
    if (remarksTagList.length > 0) {
      setRemarksList([...remarksTagList]);
    } else {
      defaultRemarksList.forEach((ele) => (ele.active = false));
      setRemarksList([...defaultRemarksList]);
    }
  }, []);

  const handleSelect = useCallback(
    (option) => {
      try {
        const remarksListCopy = [...remarksList];
        remarksListCopy.forEach((element) => {
          if (element.value === option.value) {
            element.active = !element.active;
            setSelected(element.active ? element : {});
          } else {
            element.active = false;
          }
        });
        setRemarksTagList(remarksListCopy);
        setRemarksList(remarksListCopy);
      } catch (error) {}
    },
    [remarksList]
  );

  return (
    <>
      <div>
        {remarksList.map((option, idx) => (
          <span style={{ position: "relative" }}>
            <img
              key={idx}
              src={option.active ? option.iconSelected : option.icon}
              height={25}
              width={25}
              alt="icon"
              className="mx-2"
              style={{ cursor: "pointer", marginBottom: 10 }}
              onClick={() => handleSelect(option)}
            />
            {option.active && (
              <span className="remark-txt-label">
                <Tag color="#108ee9">{option.label}</Tag>
              </span>
            )}
          </span>
        ))}
      </div>
    </>
  );
}
